import { useQuery } from 'react-query'
import { getIntake } from '../services'

export const useGetIntake = (intakeId: string) => useQuery(['intake', intakeId], () => getIntake(intakeId))

export default useGetIntake
